import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { DefaultContextWidget } from '../_utils/asDefaultWidget';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type UserImportConfigurationWidget = ContextWidget<any, WidgetType.userimportconfigurationwidget>;

export function UserImportConfigurationWidget(props: UserImportConfigurationWidget) {
  const { t } = useSonTranslation('UserImportConfiguration');

  return <DefaultContextWidget icon={Icons.CONFIG_FILE} title={t('widgetTitle')} {...props} />;
}
